// 正则变量名.test(要验证的变量)
import { service_url } from '../../services/getDomain'
const phone_regular = /^[1][3,4,5,7,8][0-9]{9}$/;    // 手机号
// const imgUrl = service_url + '/file/getImgStream?idFile='
const imgUrl = 'https://uniform.bibachina.org/mobile/file/getImgStream?idFile='
const haijia_class = [
    'KG','1','2','3','4','5'
];

export default function(Vue) {
    Vue.prototype.$commonVariable = {
        phone_regular,
        imgUrl,
        haijia_class,
    }
}

// this.$commonVariable.变量
